/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IPhonePickerViewProps } from './nos-phone-picker';

/**
 * Update Component.
 * @param param0 - Root param.
 * @param param0.phoneComponent
 * @returns - Node.
 */
const PhonePickerNode: React.FC<any> = ({ phoneComponent }) => {
    return <Node className=''>{phoneComponent}</Node>;
};

/**
 * View Component.
 * @param props - Props.
 * @returns - PhonePicker Module.
 */
const NosPhoneTypePickerView: React.FC<IPhonePickerViewProps> = props => {
    const { PhonePicker, phoneComponent } = props;
    return (
        <Module {...PhonePicker}>
            <PhonePickerNode phoneComponent={phoneComponent} />
        </Module>
    );
};

export default NosPhoneTypePickerView;
